// src/pages/TermsOfUse.jsx
export default function TermsOfUse() {
    const effectiveDate = "August 23, 2025";
    const lastUpdated = "August 23, 2025";
  
    const Section = ({ id, title, children }) => (
      <section id={id} className="rounded-2xl border bg-white shadow-sm p-6 md:p-8 mb-6 scroll-mt-24">
        <h2 className="text-2xl font-bold mb-3">{title}</h2>
        <div className="prose max-w-none text-gray-700">{children}</div>
      </section>
    );
  
    return (
      <div className="min-h-screen bg-gray-50">
        <header className="bg-gradient-to-r from-emerald-600 to-teal-600 text-white">
          <div className="max-w-6xl mx-auto px-6 py-12">
            <h1 className="text-4xl font-bold">Terms of Use</h1>
            <p className="mt-2 text-white/90 max-w-3xl">
              Please read these Terms carefully. By using our website or submitting information, you agree to them.
            </p>
            <div className="flex flex-wrap items-center gap-3 mt-5">
              <span className="inline-flex items-center rounded-full bg-white/15 px-3 py-1 text-sm">📅 Effective: {effectiveDate}</span>
              <span className="inline-flex items-center rounded-full bg-white/15 px-3 py-1 text-sm">🛠 Last Updated: {lastUpdated}</span>
            </div>
          </div>
        </header>
  
        <main className="max-w-6xl mx-auto px-6 py-10">
          <article>
            <Section id="acceptance" title="1) Eligibility & Acceptance">
              <ul className="list-disc pl-6">
                <li>You must be at least 18 years old to use our site.</li>
                <li>By using the site, you agree to these Terms and our Privacy Policy.</li>
              </ul>
            </Section>
  
            <Section id="no-advice" title="2) Not Medical or Legal Advice; No Emergency Services">
              <p>
                Content is for general informational purposes only and does not constitute medical or legal advice.
                The site does not provide emergency services—call <strong>911</strong> for emergencies.
              </p>
            </Section>
  
            <Section id="services" title="3) Services & Content">
              <ul className="list-disc pl-6">
                <li>We provide non-medical home care services; availability may vary.</li>
                <li>We may modify or discontinue site features at any time.</li>
                <li>No warranties as to accuracy, completeness, or timeliness of content.</li>
              </ul>
            </Section>
  
            <Section id="privacy-hipaa" title="4) Privacy & HIPAA">
              <p>Your use is governed by our Privacy Policy. We safeguard PHI as required by HIPAA when we provide care.</p>
            </Section>
  
            <Section id="communications" title="5) Communications Consent">
              <p>By submitting forms, you consent to receive emails/SMS/calls regarding services. Reply STOP to opt out of SMS.</p>
            </Section>
  
            <Section id="acceptable-use" title="6) Acceptable Use">
              <ul className="list-disc pl-6">
                <li>No unlawful, fraudulent, or harmful activity.</li>
                <li>No uploading malware or interfering with the site.</li>
                <li>No impersonation or rights infringement.</li>
              </ul>
            </Section>
  
            <Section id="ip" title="7) Intellectual Property; User Content & Feedback">
              <ul className="list-disc pl-6">
                <li>Site content is owned by or licensed to AllWell.</li>
                <li>Limited license for personal, non-commercial use.</li>
                <li>License to use your submitted testimonials/feedback for business purposes.</li>
              </ul>
            </Section>
  
            <Section id="links" title="8) Third-Party Links & Tools">
              <p>We are not responsible for third-party sites, content, or policies.</p>
            </Section>
  
            <Section id="disclaimers" title="9) Disclaimers & Limitation of Liability">
              <p>Provided “as is” and “as available.” Our liability is limited to the maximum extent permitted by law.</p>
            </Section>
  
            <Section id="governing-law" title="10) Governing Law; Venue">
              <p>Illinois law governs; exclusive venue is in or serving Cook County, Illinois.</p>
            </Section>
  
            <Section id="changes" title="11) Changes; Termination; Miscellaneous">
              <ul className="list-disc pl-6">
                <li>We may update these Terms at any time; continued use means acceptance.</li>
                <li>We may suspend or terminate access for any reason.</li>
                <li>Severability, no waiver, entire agreement apply.</li>
              </ul>
            </Section>
{/*   
            <Section id="contact" title="12) Contact Us">
              <div>
                <p className="font-semibold">AllWell Companion Home Care LLC</p>
                <p>Schaumburg, Illinois</p>
                <p>info@allwellcompanionhomecare.com • (630) 278-8931</p>
              </div>
            </Section>
  
            <div className="text-sm text-gray-500 mt-6">
              © {new Date().getFullYear()} AllWell Companion Home Care LLC. All rights reserved.
            </div> */}
          </article>
        </main>
      </div>
    );
  }
  